export * from './constants.base';

export const ENABLE_AUTO_SHOW_REGION_SELECTOR = true;
export const ENABLE_IDENTITY_SYNC_ON_LOGIN = true;
export const ENABLE_LEGACY_EMAIL_IMPORT = true;
export const ENABLE_LOYALTY_2_0_SEE_MORE_OPTIONS = true;
export const ENABLE_LOYALTY_20_ON_BOARDING_CONTENT_CARD_ON_THE_HOME_PAGE = true;
export const ENABLE_NO_PIN_CHECK_PREPAID_MERGE = true;
export const ENABLE_TH_DIRECT_PAY_FOR_DELIVERY = true;
export const LOYALTY_CARD_DETAILS_POLL_INTERVAL_MS = 180000;
export const ORDER_PRICE_REFRESH_INTERVAL_MS = 600000;
